var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRelayOn1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0845 20.1373L18.7731 9.49142C18.8394 9.3997 18.9831 9.47124 18.9498 9.57938L16.7863 16.6106C16.6676 16.9965 16.9561 17.3871 17.3598 17.3871H20.4768C20.7215 17.3871 20.8633 17.6643 20.72 17.8627L12.9663 28.5987C12.9024 28.6872 12.7632 28.624 12.7878 28.5177L14.4423 21.3478C14.5291 20.9718 14.2436 20.6129 13.8577 20.6129H11.3277C11.083 20.6129 10.9412 20.3357 11.0845 20.1373Z",
    fill: "url(#hinava_random_uuid_183402677756964331752440842027227449263)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9C10.4772 9 6 13.4772 6 19C6 23.0402 8.39598 26.5208 11.8446 28.0984L12.3288 26.1098C9.75745 24.7794 8 22.0949 8 19C8 14.5817 11.5817 11 16 11C16.2004 11 16.3991 11.0074 16.5958 11.0219L18 9.20004C17.3538 9.06886 16.6849 9 16 9Z",
    fill: "url(#hinava_random_uuid_249288883170397140435553560156313331711)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3338 26.9727C15.5535 26.9908 15.7756 27 16 27C20.4183 27 24 23.4183 24 19C24 15.7406 22.0507 12.9364 19.2543 11.6897L19.7606 9.73118C23.4198 11.2173 26 14.8073 26 19C26 24.5228 21.5228 29 16 29C15.3406 29 14.6961 28.9362 14.0723 28.8144L15.3338 26.9727Z",
    fill: "url(#hinava_random_uuid_108971877386901129653496601025568519088)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5C18 3.895 17.105 3 16 3C14.895 3 14 3.895 14 5C14 6.105 14.895 7 16 7C17.105 7 18 6.105 18 5Z",
    fill: "url(#hinava_random_uuid_329055667186601554398263885545148032245)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_183402677756964331752440842027227449263",
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_249288883170397140435553560156313331711",
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_108971877386901129653496601025568519088",
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_329055667186601554398263885545148032245",
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelayOn1);
export default __webpack_public_path__ + "static/media/relay-on-1.7aac72c7bf95c9e437c1c984721a6920.svg";
export { ForwardRef as ReactComponent };